import { Component } from 'react';

class Login extends Component {
  constructor(props) {
    super();
  }
  render() {
    return "You've tried a path that I don't recognize.  Is that a mistake?";
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/NoMatch.js